import { get as apiGet, post } from 'api'

export const get = async id => apiGet(`/PaymentInformation/GetPaymentInformation?invoiceId=${id}`)
export const update = async values => post('/PaymentInformation/CreatePaymentInformation', values)
